import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgJudgeHammer = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.4443 0.866211C11.9561 0.37793 11.1631 0.37793 10.6748 0.866211L5.9873 5.55371C5.49902 6.04199 5.49902 6.83496 5.9873 7.32324L6.6123 7.94824C7.10059 8.43652 7.89355 8.43652 8.38184 7.94824L8.53809 7.79199L12.71 11.96L12.5537 12.1162C12.0654 12.6045 12.0654 13.3975 12.5537 13.8857L13.1787 14.5107C13.667 14.999 14.46 14.999 14.9482 14.5107L19.6357 9.82324C20.124 9.33496 20.124 8.54199 19.6357 8.05371L19.0107 7.42871C18.5225 6.94043 17.7295 6.94043 17.2412 7.42871L17.085 7.58496L12.9131 3.41309L13.0693 3.25684C13.5576 2.76855 13.5576 1.97559 13.0693 1.4873L12.4443 0.862305V0.866211ZM6.50684 12.1162C6.01855 11.6279 5.22559 11.6279 4.7373 12.1162L0.362305 16.4912C-0.125977 16.9795 -0.125977 17.7725 0.362305 18.2607L2.2373 20.1357C2.72559 20.624 3.51855 20.624 4.00684 20.1357L8.38184 15.7607C8.87012 15.2725 8.87012 14.4795 8.38184 13.9912L8.32715 13.9365L10.624 11.6436L8.85449 9.87402L6.56152 12.167L6.50684 12.1123V12.1162Z",
		fill: "#0FAFAF"
	})
});
export default SvgJudgeHammer;
